<template>
  <v-dialog
    v-model="dialogframeboton"
    persistent
    :fullscreen="componenteview != 1 && componenteview != 2 ? true : false"
    :width="componenteview == 1 || componenteview == 2 ? '1200px' : ''"
  >
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }} -
          {{ infollaves.Contrato }} - {{ infollaves.Ref_1 }} -
          {{ infollaves.Document_ID }} - {{ infollaves.Primer_Nombre }}
          {{ infollaves.Segundo_Nombre }} {{ infollaves.Primer_Apellido }}
          {{ infollaves.Segundo_Apellido }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn class="d-none d-md-block" dark text @click="CerrarCombos()"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Consulta  Activos ¡-->
        <card-activos
          v-if="componenteview == 1"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
        ></card-activos>
        <!-- Clientes ¡-->
        <card-clientes
          v-else-if="componenteview == 2"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="llaves"
          :infopermisos="'0010'"
          :TipoSeguro="TipoSeguro"
        ></card-clientes>
        <!-- Ubicación ¡-->
        <card-direcciones
          v-else-if="componenteview == 3"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="'0010'"
        ></card-direcciones>
        <!-- Nuevo Contacto ¡-->
        <card-newcontact
          v-else-if="componenteview == 4"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="'0110'"
        ></card-newcontact>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="index"
    show-select
    return-object
    height="550px"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                v-bind:componenteview="componenteview"
                v-on:update:componenteview="componenteview = $event"
                v-bind:pageiframe="dialogframeboton"
                v-on:update:pageiframe="dialogframeboton = $event"
                v-bind:titledialogbtn="titledialogbtn"
                v-on:update:titledialogbtn="titledialogbtn = $event"
                v-bind:iconodialogbtn="iconodialogbtn"
                v-on:update:iconodialogbtn="iconodialogbtn = $event"
                v-bind:llavesiframe="llaves"
                v-on:update:llavesiframe="llaves = $event"
                :infopermisos="param1"
                :editedIndex="editedIndex"
                :infollaves="infollaves"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider
          v-if="param1[1] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider
          v-if="param1[3] == '1'"
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset"
                  >Limpiar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <v-col v-if="i == 2" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstado"
                      :item-title="
                        (ArrayEstado) =>
                          ArrayEstado.Estado_ID + '-' + ArrayEstado.Descripcion
                      "
                      item-value="Estado_ID"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="i == 3" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoObservacion"
                      :item-title="
                        (ArrayTipoObservacion) =>
                          ArrayTipoObservacion.TipoObservacion_ID +
                          '-' +
                          ArrayTipoObservacion.Descripcion
                      "
                      item-value="TipoObservacion_ID"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else-if="i == 4" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayRevision"
                      :item-title="
                        (ArrayRevision) =>
                          ArrayRevision.ValorNumero +
                          '-' +
                          ArrayRevision.Descripcion
                      "
                      item-value="ValorNumero"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 7 || i == 6 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-menu
          v-model="menubuttoms[item.raw.index]"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ props }">
            <v-icon color="red-darken-4" v-bind="props">
              mdi-file-settings</v-icon
            >
          </template>
          <v-card flat>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- Modificación  -->
                  <v-tooltip
                    v-if="param1[2] == '1' || param1[0] == '1'"
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        color="#05AD58"
                        @click="editItem(item.raw, 0)"
                        v-bind="props"
                        >{{
                          param1[2] == "1" && param1[0] == "0"
                            ? "mdi-pencil"
                            : "mdi-eye"
                        }}</v-icon
                      >
                    </template>
                    <span>{{
                      param1[2] == "1" && param1[0] == "0"
                        ? "Modificar"
                        : "Consultar"
                    }}</span>
                  </v-tooltip>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <!-- Activos -->
                  <v-tooltip location="bottom" color="white">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 1)"
                        color="cyan"
                        v-bind="props"
                        >mdi-home-group</v-icon
                      >
                    </template>
                    <span>Activos</span>
                  </v-tooltip>
                  <v-divider
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <!-- Clientes EPS-->
                  <v-tooltip
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 2)"
                        color="red"
                        v-bind="props"
                        >mdi-account</v-icon
                      >
                    </template>
                    <span>Clientes EPS</span>
                  </v-tooltip>
                  <v-divider
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <!-- Ubicación EPS -->
                  <v-tooltip
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    location="bottom"
                    color="white"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 3)"
                        color="#0D9DA9"
                        v-bind="props"
                        >mdi-map-marker-plus</v-icon
                      >
                    </template>
                    <span>Ubicación EPS</span>
                  </v-tooltip>
                  <v-divider
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <!-- Ubicación EPS -->
                  <v-tooltip
                    v-if="
                      item.raw.DocumentIDEP != '' &&
                      item.raw.DocumentIDEP != null &&
                      item.raw.DocumentIDEP != '0'
                    "
                    location="bottom"
                    color="orange"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 4)"
                        color="orange"
                        v-bind="props"
                        >mdi-account-multiple-plus</v-icon
                      >
                    </template>
                    <span>Contactos EPS</span>
                  </v-tooltip>
                  <!-- Actualización Ubicación EPS -->
                  <v-divider
                    v-if="item.raw.NombreEP && item.raw.DocumentIDEP"
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-tooltip
                    v-if="item.raw.NombreEP && item.raw.DocumentIDEP"
                    location="bottom"
                    color="purple"
                  >
                    <template v-slot:activator="{ props }">
                      <v-icon
                        @click="editItem(item.raw, 5)"
                        color="purple"
                        v-bind="props"
                        >mdi-map-marker-distance</v-icon
                      >
                    </template>
                    <span
                      >¿Desea actualizar las direcciones de todos los activos
                      del mismo EPS?</span
                    >
                  </v-tooltip>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/ActivosO/R_ServicioAdmin_Activo/R_ServicioAdmin_ActivoRegistro.vue";
import Activos from "@/views/TCI/ActivosO/Activos/Activos.vue";
import Clientes from "@/views/TCI/Personas/Clientes/Clientes.vue";
import Direcciones from "@/views/TCI/Personas/Direcciones/Direcciones.vue";
import NuevoContacto from "@/views/TCI/Personas/NuevoContacto/NuevoContacto.vue";
export default {
  name: "R_ActivoServicio",
  props: {
    infollaves: {
      type: Object,
      default: [],
      Description: "Información de llaves",
    },
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
  },
  components: {
    "proceso-registro": Registro,
    "card-activos": Activos,
    "card-clientes": Clientes,
    "card-direcciones": Direcciones,
    "card-newcontact": NuevoContacto,
  },
  data() {
    return {
      TipoSeguro: null,
      itemsPerPage: 1,
      selected: [],
      search: "",
      respuestapostput: "",
      consult: false,
      editedItem: null,
      editedIndex: -1,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      infoitem: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "RefActivo",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Activo:",
        },
        {
          campo: "IDServicio",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Servicio:",
        },
        {
          campo: "DocumentIDEP",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Empresa prestadora del servicio:",
        },
        {
          campo: "AplicaServicio",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Aplica Servicio:",
        },
        {
          campo: "Responsable",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Responsable:",
        },
        {
          campo: "FechaAsignacion",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Asignación:",
        },
      ],
      headers: [
        {
          title: "Acciones",
          key: "actions",
          align: "center",
          sortable: false,
        },
        {
          title: "Servicio",
          key: "DescIDServicio",
          width: "300px",
        },
        {
          title: "Estado Revisión",
          key: "DescEstadoRevision",
          align: "left",
        },
        {
          title: "Fecha Inicio Mora",
          key: "InicioMora",
          align: "center",
        },
        {
          title: "Valor Mora",
          key: "ValorMora",
          align: "center",
        },
        {
          title: "EPS",
          key: "NombreEP",
          width: "300px",
        },
        {
          title: "Responsable",
          key: "NombreResponsable",
          width: "300px",
        },
        {
          title: "FechaAsignacion",
          key: "FechaAsignacion",
          align: "center",
        },
      ],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      desserts: [],
      ArrayEstado: [],
      ArrayRevision: [],
      ArrayTipoObservacion: [],
      param1: [],
      busquedacompleta: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },
    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      this.axios
        .post("/ActivosO/R_ServicioAdmin_Activo/CT0/", data)
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;
      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.desserts.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
        case 1: //Activos
          this.iconodialogbtn = "mdi-home-group";
          this.titledialogbtn = "Activos";
          this.dialogframeboton = true;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 2: //Clientes EPS
          this.iconodialogbtn = "mdi-account";
          this.titledialogbtn = "Cliente Empresa Prestadora del Servicio";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentEP.toString();
          this.llaves.Document_ID = item.DocumentIDEP;
          break;
        case 3: //Ubicación EPS
          this.iconodialogbtn = "mdi-map-marker-plus";
          this.titledialogbtn = "Ubicación Empresa Prestadora del Servicio";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentEP.toString();
          this.llaves.Document_ID = item.DocumentIDEP;
          break;
        case 4: //Contactos EPS
          this.iconodialogbtn = "mdi-account-multiple-plus";
          this.titledialogbtn = "Contactos Empresa Prestadora del Servicio";
          this.dialogframeboton = true;
          this.llaves.TypeDocument_ID = item.TypeDocumentEP.toString();
          this.llaves.Document_ID = item.DocumentIDEP;
          break;
        case 5: //Actualizacion de Ubicación
          this.$swal({
            icon: "question",
            title: "Actualizacion de Ubicación Masiva por EPS",
            html:
              "¿Desea actualizar la ubicación de todos los activos de la EPS <br>«" +
              item.NombreEP +
              "»? <br> Esta acción es irreversible. ",
            confirmButtonText: "Sí",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
            if (result.isConfirmed) {
              this.updateUbicationLocatario();
            }
          });
          break;
      }
    },
    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html: "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html: "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },
    // Consulta las eliminaciones
    async getDelete() {
      this.axios
        .delete("/ActivosO/R_ServicioAdmin_Activo/", { data: this.selected })
        .then((response) => {
          if (response.data === "Exito") {
            this.$swal({
              icon: "success",
              title: "Información Eliminada",
              html: "La información se ha eliminado correctamente.",
            });
            this.getConsultData();
            this.selected = [];
          } else {
            this.$swal({
              icon: "error",
              title: "Error al guardar los datos",
              html: response.data.toString(),
            });
          }
        })
        .catch((e) =>
          this.$swal({
            icon: "error",
            title:
              "No se logro la eliminación debido a que tiene datos relacionados",
            html:
              "Lo sentimos, ocurrió un error al intentar consultar los datos del proceso:<br><small><code>" +
              e.toString() +
              "</code></small>",
          })
        );
    },

    // Get para Actualizacion Ubicacion Locatarios
    async updateUbicationLocatario() {
      if (
        this.infoitem.TypeDocumentEP != "" &&
        this.infoitem.TypeDocumentEP != null &&
        this.infoitem.DocumentIDEP != "" &&
        this.infoitem.DocumentIDEP != null
      ) {
        this.progreso = true;
        this.axios
          .get(
            "/ActivosO/R_ServicioAdmin_Activo/UpdateUbicacionMasivaEps/" +
              this.infoitem.TypeDocumentEP +
              "/" +
              this.infoitem.DocumentIDEP +
              "/" +
              this.infollaves.Contrato
          )
          .then((response) => {
            if (response.data.Status == 200) {
              this.$swal({
                icon: "success",
                title: "¡Éxito!",
                html: " El registro fue guardado correctamente.",
              });
            } else {
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  response.data.Message +
                  "</code></small>",
              });
            }
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror = registro.Mensaje || registro.ExceptionMessage;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          })
          .finally(() => {
            this.progreso = false;
          });
      }
    },

    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Cerrar combos
    CerrarCombos() {
      this.dialogframeboton = false;
      this.llaves.TypeDocument_ID = null;
      this.llaves.Document_ID = null;
      this.llaves.Primer_Apellido = null;
      this.llaves.Primer_Nombre = null;
      this.llaves.Segundo_Nombre = null;
      this.llaves.Solicitud = null;
      this.llaves.Contrato = null;
      this.llaves.Ref_1 = null;
      this.llaves.Ref_2 = null;
      this.llaves.Ref_3 = null;
      this.llaves.IDServicio = null;
      this.llaves.IDPoliza = null;
    },
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.pageiframe) {
        if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
          this.modelfiltro[0].contenido = this.infollaves.Ref_1;
          this.modelfiltro[0].lectura = true;
          this.modelfiltro[0].clear = false;
          this.modelfiltro[0].filtro = "=";
        }
        if (
          this.infollaves.IDServicio != null &&
          this.infollaves.IDServicio != ""
        ) {
          this.modelfiltro[1].contenido = this.infollaves.IDServicio;
          this.modelfiltro[1].lectura = true;
          this.modelfiltro[1].clear = false;
          this.modelfiltro[1].filtro = "=";
        }
      }
    },
    // Cargue Combo
    CargueCombo() {},
    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
      }
    },
    // Parametros Iframe
    parametrosiframe() {
      if (this.infollaves.Ref_1 != null && this.infollaves.Ref_1 != "") {
        this.modelfiltro[0].contenido = this.infollaves.Ref_1;
        this.modelfiltro[0].lectura = true;
        this.modelfiltro[0].clear = false;
        this.modelfiltro[0].filtro = "=";
      }
      if (
        this.infollaves.IDServicio != null &&
        this.infollaves.IDServicio != ""
      ) {
        this.modelfiltro[1].contenido = this.infollaves.IDServicio;
        this.modelfiltro[1].lectura = true;
        this.modelfiltro[1].clear = false;
        this.modelfiltro[1].filtro = "=";
        // Tipo de seguro
        this.TipoSeguro =
          this.$store.getters.MServicio[this.infollaves.IDServicio].TipoSeguro;
      }
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
